import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileItem, FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { DialogService } from '../../dialogs/core/dialog.service';
import { FileService } from '../core/file.service';
import { RlFile } from '../shared/rl-file';

@Component({
  selector: 'rl-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FileUploadComponent
    }
  ]
})
export class FileUploadComponent implements OnInit, ControlValueAccessor {
  @Input() folder: boolean = false;
  @Input() deleteMsg: string;
  @Input() format?: boolean = false;
  @Input() acceptedTypes?: string = 'application/pdf';
  @Input() displayUploadFileButton: boolean = false;
  @Input() uploadType: string = 'file';
  @Output() onUpload = new EventEmitter<RlFile>();
  @Output() onRemove = new EventEmitter<RlFile>();

  uploader: FileUploader;
  response: string;
  dropFileTypeLabel: string;
  dropSingleOrFolderLabel: string;
  dragOver: boolean = false;
  fileUploadOpen: boolean = false;

  //files : {[key : string] : [FileItem, RlFile]} = {};
  files: { [key: string]: RlFile } = {};

  constructor(private fileService: FileService, private dialog: DialogService, private ngZone: NgZone) {
    this.uploader = new FileUploader({
      url: '',
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      parametersBeforeFiles: true
      //maxFileSize :
      //allowedFileType
      //allowedMimeType ?
    });

    this.response = '';

    this.uploader.response.subscribe((res) => {
      this.response = res;
    });

    this.uploader.onBeforeUploadItem = (file: FileItem) => {
      let key = this.getKey(file);
      this.files[key].fileItem = file;
    };

    this.uploader.onCompleteItem = (file: FileItem) => {
      let key = this.getKey(file);
      this.onUpload.emit(this.files[key]);
    };

    this.uploader.onSuccessItem = (file: FileItem, response: string) => {
      let key = this.getKey(file);
      this.files[key].results = response;
      this.onChange(this.files[key]);
      // let key = this.getKey(file);
      // this.files[key][0] = file;
      // this.files[key][1].results = response;
      // this.onChange(this.files[key][1]);
    };

    // this.uploader.onCancelItem = (file: FileItem)  => {
    //   let key = this.getKey(file);

    //   if(!this.files[key][0]){ //this.files[key][1].entityId
    //     dialog.openDeleteDialog(this.deleteMsg, () => {
    //         fileService.delete(this.files[key][1]).subscribe(res => {
    //           this.uploader.removeFromQueue(file);
    //         });
    //     });
    //   }else{
    //     this.uploader.removeFromQueue(file);
    //   }
    // }
  }

  delete = (file: RlFile) => {
    if (this.files[file.amazonFileKey].fileItem) {
      this.files[file.amazonFileKey].fileItem.cancel();
      //this.uploader.removeFromQueue(file);
      return;
    }

    //this.files[key][1].entityId
    this.dialog.openDeleteDialog(this.deleteMsg, () => {
      this.fileService.delete(file).subscribe((res) => {
        delete this.files[file.amazonFileKey];
        //this.uploader.removeFromQueue(file);
      });
    });
  };

  getKey = (file: FileItem) => file._file['key'];

  ngOnInit(): void {
    this.dropFileTypeLabel = this.format ? 'citation.edit.drag.file.here.' + this.format : 'citation.edit.drag.file.here.all';
    this.dropSingleOrFolderLabel = this.folder ? 'citation.edit.drag.folder.or' : 'citation.edit.drag.file.or';
  }

  upload(e) {
    const fileExtension = e[0].name.split('.')[e[0].name.split('.').length - 1].toLowerCase();
    let rlFile = new RlFile();
    if ('exe' === fileExtension) {
      rlFile.errors.push('fileUpload.error.invalidType');
      return;
    }

    //does policy called multi times?
    this.fileService.getAmazonPolicy(this.uploadType).subscribe((policy: any) => {
      let fileName = `${policy.random}-${e[0].name}`;
      let fileKey = `${policy.account.uploadPath}/${fileName}`;
      let op: FileUploaderOptions = {
        url: `https://${policy.endpoint}/${policy.account.bucket}/`,
        method: 'POST',
        additionalParameter: {
          key: fileKey,
          policy: policy.policy,
          'X-Amz-Algorithm': 'AWS4-HMAC-SHA256',
          'X-Amz-Credential': policy.amzCredential,
          'X-Amz-Date': policy.nowAsISO,
          'X-Amz-Signature': policy.signature,
          acl: policy.account.acl,
          success_action_status: '201',
          'Content-Type': e[0].type === null || e[0].type === '' ? 'application/octet-stream' : e[0].type
        },
        itemAlias: fileKey
      };

      e[0].key = fileName;

      this.addFileToFiles(e[0]);

      this.uploader.setOptions(op);

      this.uploader.uploadAll();
    });
  }

  addFileToFiles(f: File) {
    let rlFile = new RlFile();
    rlFile.amazonFileKey = f['key'];
    rlFile.amazonDisplayFileName = f.name;
    this.files[rlFile.amazonFileKey] = rlFile;
  }

  //////// ControlValueAccessor methods
  writeValue(obj: RlFile): void {
    //this.files[obj.amazonFileKey] = [undefined, obj];
    if (obj.amazonFileKey) {
      this.files[obj.amazonFileKey] = obj;
    }
    //this.uploader.addToQueue()
  }

  onChange = (file: RlFile) => {};
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    //throw new Error('Method not implemented.');
  }

  clickFileUploadButton(): void {
    this.ngZone.run(() => (this.fileUploadOpen = !this.fileUploadOpen));
  }
  ///////
}
